import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  evt_id: string().required(),
  token: string().required(),
});

/**
 * ClientAuthEvent
 *
 * - Esse evento deve ser enviado a cada 30 segundos para manter a conexão com o servidor.
 * - Caso o cliente não envie esse evento, o servidor irá enviar um evento de `SystemHeartbeat` para o cliente, que deve responder enviando um `ClientAuthEvent` de volta em até 5s.
 */
export class ClientAuthEvent extends CreateCommand(RealtimeEventType.ClientAuth, SCHEMA) {}
